import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Select as AntdSelect, SelectProps as AntdSelectProps } from 'antd';
import { Suffix } from '../Suffix/Suffix';

interface SelectProps<T = any> extends AntdSelectProps<T> {
  suffix?: string;
}

const StyledSelect = styled(AntdSelect)<SelectProps>`
  font-size: 18px;
  position: relative;

  .ant-select-clear {
    position: absolute;
    top: 7px;
    right: 4px;
    padding: 19px;
    opacity: 100%;
    display: flex;
    justify-content: center;
  }

  .ant-select-arrow {
    margin-right: 40px;
  }

  .ant-select-arrow:last-child {
    margin-right: 0;
  }

  .ant-select-selector {
    ${({ suffix }) =>
      suffix &&
      css`
        border-radius: 4px 0px 0px 4px !important;
        border-right: 0px !important;
        font-size: 18px;
      `}
  }
`;

export function Select<T>(props: SelectProps<T>): JSX.Element {
  const { suffix } = props;
  return (
    <div style={{ display: 'flex' }}>
      <StyledSelect<FC<SelectProps<T>>> {...props} />
      {suffix && <Suffix value={suffix} />}
    </div>
  );
}

Select.Option = AntdSelect.Option;
